// 全局配置， 通过全局混入注入到每个vue组件实例
const CONFIG = {};

export default CONFIG;
